
import wixWindow from 'wix-window';

if (wixWindow.formFactor === "Desktop") {

$w.onReady(function () {
    makeResponsive("#text1","h2",6,"#A3956D",1.2, 0.3, 80);

})}
 
// Responsive Text Function - Do Not Edit
function makeResponsive(elementId,textTheme,fontSize,fontColor,lineHeight,charSpacing,width) {
let style = "font-size:"+fontSize+"vw;color:"+fontColor+";line-height:"+lineHeight+";letter-spacing:"+charSpacing+"vw;width:"+width+"vw";
$w(elementId).html = "<"+textTheme+" style="+style+">"+$w(elementId).text+"</"+textTheme+">";
}